import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'

import Box from '../component/Box/Box'
import Page from '../component/Page/Page'
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem'
import { InputWithLabel } from '../component/Form/InputWithLabel'
import FormButtons from '../component/Form/FormButtons'
import FileReaderHandler from '../utils/FileReaderHandler'
import Notify from '../services/Notify'
import InventoryService from '../services/InventoryService'

function InventoryExecutionScreen({ match, history }) {
  const [readTags, setReadTags] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const inventoryService = new InventoryService()

  const { params: routeParams } = match

  const executeInventory = async (event) => {
    event.preventDefault()
    try {
      setIsLoading(true)
      const body = {
        epcsRead: readTags,
        unexpected: [],
        expected: [],
        notFound: [],
        doneDate: new Date()
      }
      await Notify.promise(inventoryService.finishInventory(routeParams.inventoryId, body), {
        pending: 'Finalizando inventário...',
        success: 'Inventário finalizado!',
        error: 'Houve um erro ao finalizar o inventário'
      })
      history.push('/list/inventories')
    } finally {
      setIsLoading(false)
    }
  }

  const onSelectFile = (event) => {
    const target = event.target
    const file = event.target.files[0]
    const fileReader = new FileReaderHandler()
    const epcs = []
    const inventoryFilePattern = /^.+"Inventory"	/gm
    
    if (!file) {
      return
    }

    const onReadLine = (lineContent) => {
      if (inventoryFilePattern.test(lineContent)) {
        let tagId = lineContent.replace(inventoryFilePattern, '')
        tagId = tagId.replace(/-/gm, '')
        tagId = tagId.replace(/(\r\n|\n|\r)/gm, '')
        tagId = tagId.substr(-28).substring(0, 24)
        epcs.push(tagId)
      }
    }

    const onFinish = () => {
      if (epcs.length > 0) {
        setReadTags(epcs)
      } else {
        Notify.error('Erro ao importar arquivo', new Error('O arquivo selecionado não atende os padrões'))
        target.value = '' // Reset input file state if not match pattern
      }
    }

    fileReader.readFileLineByLine(file, onReadLine, onFinish)
  };

  useEffect(() => {
    Notify.dismissAll()
  }, [])

  const breadcrumbs = [
    <BreadcrumbItem key={1} title="Lista de inventários" to="/list/inventories" />,
    <BreadcrumbItem key={1} title="Execução do inventário" />
  ]

  return (
    <Page title="Execução do inventário" breadcrumbs={breadcrumbs}>
      <Box title="Selecionar arquivo de inventário">
        <Form onSubmit={executeInventory}>
          <InputWithLabel
            className="mt-3 mb-3"
            inputType="file"
            required
            onChange={onSelectFile}
          />
          <FormButtons history={history} isLoading={isLoading}/>
        </Form>
      </Box>
    </Page>
  )
}

export default InventoryExecutionScreen



// WEBPACK FOOTER //
// ./src/Inventory/InventoryExecutionScreen.js